'use strict';
import * as $j_app$002eapi$002e$002dDrug$002dRequest$002dData$0024 from "./app.api.-Drug-Request-Data$.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_api_DrugRequestsAcceptedListItem$$anon$39() {
}
export { $c_Lapp_api_DrugRequestsAcceptedListItem$$anon$39 as $c_Lapp_api_DrugRequestsAcceptedListItem$$anon$39 };
$c_Lapp_api_DrugRequestsAcceptedListItem$$anon$39.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_api_DrugRequestsAcceptedListItem$$anon$39.prototype.constructor = $c_Lapp_api_DrugRequestsAcceptedListItem$$anon$39;
/** @constructor */
function $h_Lapp_api_DrugRequestsAcceptedListItem$$anon$39() {
}
export { $h_Lapp_api_DrugRequestsAcceptedListItem$$anon$39 as $h_Lapp_api_DrugRequestsAcceptedListItem$$anon$39 };
$h_Lapp_api_DrugRequestsAcceptedListItem$$anon$39.prototype = $c_Lapp_api_DrugRequestsAcceptedListItem$$anon$39.prototype;
$c_Lapp_api_DrugRequestsAcceptedListItem$$anon$39.prototype.toString__T = (function() {
  return "<function0>";
});
$c_Lapp_api_DrugRequestsAcceptedListItem$$anon$39.prototype.apply__O = (function() {
  return $j_app$002eapi$002e$002dDrug$002dRequest$002dData$0024.$m_Lapp_api_DrugRequestData$().derived$Schema__Lsttp_tapir_Schema();
});
var $d_Lapp_api_DrugRequestsAcceptedListItem$$anon$39 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_api_DrugRequestsAcceptedListItem$$anon$39, "app.api.DrugRequestsAcceptedListItem$$anon$39", ({
  Lapp_api_DrugRequestsAcceptedListItem$$anon$39: 1,
  F0: 1,
  Ljava_io_Serializable: 1,
  Lmagnolia1_SerializableFunction0: 1
}));
export { $d_Lapp_api_DrugRequestsAcceptedListItem$$anon$39 as $d_Lapp_api_DrugRequestsAcceptedListItem$$anon$39 };
//# sourceMappingURL=app.api.-Drug-Requests-Accepted-List-Item$$anon$39.js.map
